import { useRef, useState } from 'react';

export function useListScreenState() {
  const [scrollNode, setScrollNode] = useState<HTMLDivElement | null>(null);
  const triggerRef = useRef<HTMLDivElement | null>(null);

  return { scrollNode, setScrollNode, triggerRef };
}
